<template>
<div class="background-slider absolute w-full h-full left-0 top-0 overflow-hidden">

    <BackgroundImage v-if="count && count === 1" class="slide" parallax="0.15" :alt="images[0].alt" :src="images[0].src" ></BackgroundImage>
    
    <template v-if="count && count > 1">
        <BackgroundImage :class="appState" class="next-slide slide" parallax="0.15" :alt="nextSlide.alt" :src="nextSlide.src" position="bg-top"></BackgroundImage>
        <BackgroundImage :class="`${appState} slide-${currentIndex}`" class="current-slide slide" parallax="0.15" :alt="currentSlide.alt" :src="currentSlide.src" position="bg-top"></BackgroundImage>
    </template>
    
</div>
</template>

<script>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import BackgroundImage from './BackgroundImage.vue';

export default {

    props: ['images'],
    
    setup(props) {

        const currentIndex = ref(0);
        const appState = ref('idle');
        let loop;

        const currentSlide = computed(() => {
            return props.images[currentIndex.value];
        });

        const nextSlide = computed(() => {
            return (currentIndex.value === props.images.length - 1)
                ? props.images[0]
                : props.images[currentIndex.value + 1];
        });

        const next = () => {
            currentIndex.value = (currentIndex.value === props.images.length - 1)
                ? 0
                : currentIndex.value + 1;
        };

        // preload images
        onMounted(() => {
            for (let i = 0; i < props.images.length; i++) {
                let bucket = new Image();
                bucket.src = props.images[i].src;
            }
        });

        onMounted(() => {

            const slideIt = () => {
                appState.value = 'transitioning';
                window.wait(3500).then(() => {
                    next();
                    appState.value = 'idle';
                });
            };

            slideIt();
            loop = window.setInterval(slideIt, 7000);

        });

        onBeforeUnmount(() => {
            window.clearInterval(loop);
        });

        const count = computed(() => {
            let output = props.images.length;
            if (!output) {
                return 0;
            }
            if (window.prefersReducedMotion()) {
                return 1;
            }
            return output;
        });

        return {
            appState,
            currentIndex,
            currentSlide,
            count,
            nextSlide
        }

    },

    components: {
        BackgroundImage
    }

}
</script>